import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { ModalComponent } from "src/app/shared/modals/modal.component";
import { ApiService } from "src/app/shared/services/api.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})
export class SidebarComponent implements OnInit {

  isDoctor: boolean = false;

  @ViewChild('modal') modal!: ModalComponent;
  collapseShow = "hidden";
  constructor(private oidcSecurityService: OidcSecurityService,
    public apiService: ApiService,
    private router: Router) {}

  ngOnInit() {
    this.isUserDoctor();
  }
  toggleCollapseShow(classes) {
    this.collapseShow = classes;
  }

  isUserDoctor() { 
    this.apiService.apiCall('get', '/api/SiteDoctors/GetDoctorRole', {}).subscribe((res: any) => {
        console.log('/*/*/*/*/*/*/*/',res);
        this.isDoctor = res.body?.model?.isDoctor ?? false; // Ensure safe access & return false if undefined
    });

  }

  logout() {
    this.oidcSecurityService.logoff().subscribe((res: any) => {
      console.log(res);

      this.router.navigate(['/']);
      
    })
  }

  // openModal() {
  //   this.modal.open();
  // }

  // closeModal() {
  //   this.modal.close();
  // }

}
